var map = {
	"./7.jpg": 23215,
	"./7.webp": 26158,
	"./CHIS_agua_azul_46.jpg": 96096,
	"./CuatroCienagasCoahuila.jpg": 51716,
	"./GlobosLeonGuanajuato.jpg": 78820,
	"./GolfBCS.jpg": 56204,
	"./GolfBCS.webp": 1180,
	"./Grutas_Tolantongo_B_2C_Cardonal.jpg": 94416,
	"./LABUFADORAENSENADABC.jpg": 93500,
	"./LABUFADORAENSENADABC.webp": 24168,
	"./MazatlanSinaloa.webp": 48224,
	"./ROO_PlayaDelCarmen_Kayak-1137.jpg": 24836,
	"./SIN_guanacoa_257.webp": 54520,
	"./TRAVESIA-3(1).webp": 66592,
	"./loreto.jpg": 79296,
	"./sinaloa.jpg": 72428
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94128;